import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const SOFT_LOGINS = [
  {
    id: 'master',
    label: 'Master Admin',
    hint: 'Full platform control',
    username: 'admin',
    password: 'password123',
  },
  {
    id: 'group',
    label: 'Group Admin',
    hint: 'Manage group buys & discounts',
    username: 'groupadmin',
    password: 'password123',
  },
  {
    id: 'member',
    label: 'Member',
    hint: 'Record purchases & view savings',
    username: 'member1',
    password: 'password123',
  },
];

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();

  const doLogin = async (user, pass) => {
    setError('');
    setBusy(true);
    try {
      await login(user, pass);
    } catch (err) {
      const status = err.response?.status;
      const detail = err.response?.data?.detail || err.response?.data?.error;
      if (status === 401) {
        setError(
          detail
            || 'Invalid credentials. Soft login uses password123 — restart backend to re-seed: docker compose restart backend'
        );
      } else if (!err.response) {
        setError('Cannot reach API (http://localhost:9027). Is ace_backend running?');
      } else {
        setError(detail || `Login failed (${status})`);
      }
    } finally {
      setBusy(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await doLogin(username, password);
  };

  const softLogin = async (preset) => {
    setUsername(preset.username);
    setPassword(preset.password);
    await doLogin(preset.username, preset.password);
  };

  return (
    <div className="login-container">
      <div className="login-shell">
        <aside className="login-aside">
          <p className="login-eyebrow">Group procurement</p>
          <h1>Ace Kaatha</h1>
          <p className="login-lead">
            Members pool purchases, unlock bulk discounts, then bookkeeping closes the loop —
            trial balance, tax, and period lock in one place.
          </p>
          <ol className="login-flow">
            <li>Members record purchases</li>
            <li>Group admin aggregates the pool</li>
            <li>Discounts distribute by share</li>
            <li>Ledgers &amp; tax stay in sync</li>
          </ol>
        </aside>

        <div className="login-box">
          <h2>Sign in</h2>
          <p className="subtitle">Use a soft login for local demo, or enter credentials.</p>

          <div className="soft-login-grid">
            {SOFT_LOGINS.map((preset) => (
              <button
                key={preset.id}
                type="button"
                className="soft-login-btn"
                disabled={busy}
                onClick={() => softLogin(preset)}
              >
                <strong>{preset.label}</strong>
                <span>{preset.hint}</span>
                <em>{preset.username}</em>
              </button>
            ))}
          </div>

          <div className="login-divider"><span>or continue with</span></div>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Username</label>
              <input
                type="text"
                autoComplete="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="admin"
                required
              />
            </div>
            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>
            {error && <div className="error">{error}</div>}
            <button type="submit" className="btn btn-primary login-submit" disabled={busy}>
              {busy ? 'Signing in…' : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
